module.exports = __webpack_public_path__ + "static/media/IMG_0901.0990054d.jpg";